import React from "react";
import {Image} from 'react-bootstrap';

import "./AboutBand.css";

import aboutband_icon_01 from "../../asset/images/aboutband_icon_01.png";
import aboutband_icon_02 from "../../asset/images/aboutband_icon_02.png";
import aboutband_icon_03 from "../../asset/images/aboutband_icon_03.png";
import aboutband_icon_04 from "../../asset/images/aboutband_icon_04.png";

// 关于我们中部banner
class AboutBand extends React.Component {
  render() {
    return (
      <div className="aboutband">
        <div className="aboutband_icons">
          <div className="aboutband_icon">
            <Image src={aboutband_icon_01} />
            <div className="aboutban_word">正直</div>
          </div>
          <div className="aboutband_icon">
            <Image src={aboutband_icon_02} />
            <div className="aboutban_word">专业</div>
          </div>
          <div className="aboutband_icon">
            <Image src={aboutband_icon_03} />
            <div className="aboutban_word">高效</div>
          </div>
          <div className="aboutband_icon">
            <Image src={aboutband_icon_04} />
            <div className="aboutban_word">创赢</div>
          </div>
        </div>
      </div>
    )
  }
}

export default AboutBand
